
// https://developers.heap.io/reference#track
export enum UserSurveyEvent {
  SignatureRequestSent = 'signature_request_sent',
  DocsRedesignPaidControl = 'docs_redesign_paid_control',
  TemplatesPageClick = 'templates_page_click',
  StarredTemplatesPageClick = 'starred_templates_page_click',
}

export enum UserSurveyPosition {
  BottomLeft = 'bottomLeft', // UserLeap default
  BottomRight = 'bottomRight',
  TopLeft = 'topLeft',
  TopRight = 'topRight',
  Center = 'center',
}

declare global {
  interface Window {
    UserLeap?: {
        (call: string, value: string | string[]) : () => void;
        (call: string, key: string, value: string | number) : () => void;
        framePosition : string;
    }
  }
}

function trackEvent(eventName: UserSurveyEvent) {
  if ('UserLeap' in window && window.UserLeap && eventName) {
    window.UserLeap('track', eventName);
  }
}

function setPosition(position: UserSurveyPosition) {
  if ('UserLeap' in window && window.UserLeap) {
    window.UserLeap.framePosition = position;
  }
}

function addAttribute(key: string, value: string | number) {
  if ('UserLeap' in window && window.UserLeap) {
    window.UserLeap('setAttribute', key, value);
  }
}

function removeAttribute(key: string) {
  if ('UserLeap' in window && window.UserLeap) {
    window.UserLeap('removeAttributes', [key]);
  }
}

export const UserSurvey = {
  trackEvent,
  setPosition,
  addAttribute,
  removeAttribute,
};
